/*
 *
 * Date: 2025
 * Description: Rules execution and errors handling for forms
 * Author: Philippe Leroux @SKITSC
 *
 */

//Interfaces
import { i_user_login, t_user_fields , i_user } from "../interfaces/user.interface";

//Rules
import { userRules, userUpdateRules } from "./rules";
const sanitizeLogin = ( form : i_user_login ) : [ boolean , t_user_fields , string] => {
    //To do validation here...
    return [ true , 'username' , '']
}

const sanitizeUser = ( form : i_user , method : "POST" | "PUT") : [ boolean, t_user_fields, string ] => {
    var rules = userRules
    if(method === 'PUT') rules = userUpdateRules
    const executeRules = ( body : i_user ) : [ boolean , string , t_user_fields ] => {
        for(const validation of rules) { 
            const { field, validate, error } = validation; if (!validate(body[field])) return [false, error, field];
        }
        return [true, '', 'username'];
    }
    const [ valid , error , field ] = executeRules(form);
    if(valid) {
        return [ true, 'username', '' ]
    }else{

        return [ false, field, error ]
    }
}


export { sanitizeLogin , sanitizeUser};